import React from "react";
//import TopBar from "./TopBar";
import MainHeader from "./MainHeader";

export default function Header() {
  return (
    <>
      {/* <TopBar /> */}
      <MainHeader />
    </>
  );
}
